var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 1.5H17.3496V15.3803C17.3496 17.0372 16.0065 18.3803 14.3496 18.3803H2.5V4.5C2.5 2.84315 3.84315 1.5 5.5 1.5ZM15.6997 14.7302V3.14996H6.14994C5.04537 3.14996 4.14994 4.04539 4.14994 5.14996V16.7302H13.6997C14.8042 16.7302 15.6997 15.8348 15.6997 14.7302Z",
    fill: "#F16434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58592 13.8667C8.14598 13.7264 7.51727 12.6646 7.31447 12.0736L8.66314 11.4225C8.87609 11.9434 9.32227 12.4242 10.0422 12.4242C10.6304 12.4242 10.9853 12.1237 10.9853 11.6128C10.9853 10.2706 7.55784 10.4909 7.55784 7.97666C7.55784 6.79466 8.32851 5.94322 9.58592 5.77293V5.15187H10.5594V5.79296C11.7864 6.00332 12.334 6.95493 12.5064 7.4658L11.178 8.0568C11.0056 7.68617 10.7115 7.20536 10.022 7.20536C9.47438 7.20536 9.16002 7.5259 9.16002 7.95663C9.16002 9.25884 12.6179 9.06852 12.6179 11.5026C12.6179 12.7047 11.8574 13.6262 10.5695 13.8366V14.6981H9.58592V13.8667Z",
    fill: "#F16434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.754679e7f338255a75aeae0ee11a1b84.svg";
export { ForwardRef as ReactComponent };